type DraftCostLine = {
  line_id?: string
  price_item_id?: string
  unit_cost: string | null
}

type SavedCostLine = { line_id: string; unit_cost?: number }
type CatalogCostItem = { _id: string; unit_cost?: number }

/** Fill previously hidden costs without replacing any value the editor already knows. */
export function hydrateExternalDraftCosts<T extends DraftCostLine>(
  lines: T[],
  savedLines: readonly SavedCostLine[] = [],
  priceItems: readonly CatalogCostItem[] = [],
): T[] {
  let changed = false
  const hydrated = lines.map((line) => {
    if (line.unit_cost !== null) return line
    // Historical lines must use their snapshot, never a newer catalog price.
    const cost = line.line_id
      ? savedLines.find((saved) => saved.line_id === line.line_id)?.unit_cost
      : priceItems.find((item) => item._id === line.price_item_id)?.unit_cost
    if (cost === undefined) return line
    changed = true
    return { ...line, unit_cost: String(cost) }
  })
  return changed ? hydrated : lines
}

export function defaultExternalPrescriber(profile?: { ruolo: string; nome?: string; cognome?: string } | null): string {
  return profile && ['clinic_owner', 'dentista'].includes(profile.ruolo)
    ? [profile.nome, profile.cognome].filter(Boolean).join(' ')
    : ''
}
